// import { toRem, toRems } from '../../../../../helpers/theme'

/* eslint-disable quote-props, no-dupe-keys, max-len */
import { toRem } from "../../../../../helpers";

const style = ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("xl")]: {
        flexDirection: "row",
    },
    "& .userProfileContent": {
        "&_primary": {
            marginTop: toRem(20),
            [theme.breakpoints.up("md")]: {
                marginTop: toRem(40),
                paddingLeft: toRem(8),
            },
            "& + .userProfileContent_secondary": {
                [theme.breakpoints.up("xl")]: {
                    marginLeft: toRem(115),
                },
            },
        },
        "&_secondary": {
            flex: "0 0 auto",
        },
        "&_lead": {
            p: {
                fontSize: toRem(16),
                [theme.breakpoints.up("md")]: {
                    fontSize: toRem(22),
                },
                lineHeight: 1.6,
            },
        },
        "&_lead + .userProfileContent_text": {
            marginTop: toRem(15),
            [theme.breakpoints.up("md")]: {
                marginTop: toRem(30),
            },
        },
        "&_text": {
            p: {
                display: "none",
                fontSize: toRem(14),
                [theme.breakpoints.up("md")]: {
                    display: "inline-block",
                    fontSize: toRem(16),
                },
                lineHeight: 1.6,
            },
        },
    },
});

export default style;
